import type { HTTPHeaders } from "../api";
import { Configuration } from "../api";
import { store } from "../store";

export interface CreateApiConfigurationOptions {
    /** URL to react the backend under. Defaults to `""` (same URL as frontend).*/
    readonly basePath?: string;
    /**
     * Optional additional headers to pass to the request.
     * These may be amended later.
     */
    readonly headers?: HTTPHeaders;
}

/** Create configuration for the backend API. */
export const apiConfiguration = new Configuration({
    basePath: "/api/v1",
    // the openAPI client does not allow the login token to be
    // `undefined`, but checks for its validity using
    // if (loginToken) nontetheless.
    // So we can just use "" instead of `undefined`.
    accessToken: () => store.serviceLoginToken.loginToken?.token || "",
});
